import VerifiedIcon from '@mui/icons-material/Verified'
import { Box, CircularProgress, Typography } from '@mui/material'

const ConnectingToAxle = (): JSX.Element => {
  return (
    <Box
      sx={{
        backgroundColor: 'background.paper',
        borderRadius: 2,
        boxShadow: 3,
        p: 3,
        mx: 'auto',
        mt: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        width: '100%',
      }}
    >
      {/* Optional Verified Icon to match previous design */}
      <VerifiedIcon sx={{ fontSize: 50, color: 'info.main', mb: 2 }} />

      {/* Loading Message */}
      <Typography variant="h6" sx={{ color: 'text.primary', mb: 2 }}>
        We are connecting to Axle...
      </Typography>

      {/* Circular Progress Indicator */}
      <CircularProgress color="primary" />
    </Box>
  )
}

export default ConnectingToAxle
